import dayjs from 'dayjs';
import { z } from 'zod';

import type { Address } from '@/models/Address.ts';
import type { Phone } from '@/models/Phone.ts';

export const PersonInfoSchema = z.object({
  id: z.string(),
  firstName: z.string(),
  lastName: z.string(),
  dateOfBirth: z.string(),
  gender: z.string(),
  email: z.string(),
  address: z.custom<Address>(),
  nino: z.string(),
  phoneNumbers: z.array(z.custom<Phone>()),
  createDate: z.string(),
  lastUpdateDate: z.string(),
});
export type PersonInfo = z.infer<typeof PersonInfoSchema>;

export function getPersonInfoFullName(personInfo?: {
  firstName: string;
  lastName: string;
  fullName?: string;
}) {
  if (!personInfo) {
    return '';
  }
  if (personInfo.fullName) {
    return personInfo.fullName;
  }
  return `${personInfo.firstName} ${personInfo.lastName}`;
}

export function divideFullName(fullName: string) {
  const names = fullName.split(' ');
  return {
    firstName: names[0],
    lastName: fullName.replace(names[0], '').trim(),
  };
}

export function computeAge(personInfo: { dateOfBirth: string }) {
  return dayjs().diff(dayjs(personInfo.dateOfBirth), 'year');
}
